import { render } from "./HelloWorld.vue?vue&type=template&id=41ee0e74&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=41ee0e74&scoped=true&lang=less"

import exportComponent from "C:\\Users\\rw445\\workspace\\test-typescript\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ee0e74"]])

export default __exports__